// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__sBYzu","skeleton-animation":"styles_skeleton-animation__tt6ya"};